module.exports = __webpack_public_path__ + "static/media/21ECLAC21.8a155a04.jpg";